import { Text, ITextProps } from '@fluentui/react/lib/Text';

export interface IPTextProps extends ITextProps {}

export const IPText = (props: IPTextProps) => {
  return <Text {...props} />;
};